import { connect } from 'react-redux';

import { SignupForm } from 'components/SignupForm';
import {
  submitCreateAccountForImportForm,
  showRequestResetPassword,
} from 'client/user';

const mapDispatchToProps = (dispatch, { submitCallback }) => ({
  onSubmit: ({ data, setError, locale }) =>
    dispatch(
      submitCreateAccountForImportForm(data, submitCallback, setError, locale)
    ),
  loginUrl: '/switch/login',
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = () => ({
  isImporting: true,
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupForm);
